import { render } from "./patientInfo.vue?vue&type=template&id=2996089a&scoped=true"
import script from "./patientInfo.vue?vue&type=script&lang=js"
export * from "./patientInfo.vue?vue&type=script&lang=js"

import "./patientInfo.vue?vue&type=style&index=0&id=2996089a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2996089a"]])

export default __exports__